import React from "react";
import { useNavigate } from "react-router-dom";
import {
  UserAddOutlined,
  TeamOutlined,
  PictureOutlined,
  DollarOutlined,
  WalletOutlined,
  BarChartOutlined,
  SettingOutlined,
  FileTextOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import "./QuickActions.css";

function QuickActions() {
  const navigate = useNavigate();

  const actions = [
    {
      icon: <UserAddOutlined />,
      label: "Add User",
      color: "pink",
      path: "/User_Reg_WO",
    },
    {
      icon: <TeamOutlined />,
      label: "Add Profile",
      color: "purple",
      path: "/User_Reg_WO",
    },
    {
      icon: <PictureOutlined />,
      label: "Add Banner",
      color: "yellow",
      path: "/banners",
    },
    {
      icon: <DollarOutlined />,
      label: "Payments",
      color: "green",
      path: "/Transaction",
    },
    {
      icon: <WalletOutlined />,
      label: "Withdrawals",
      color: "blue",
      path: "/Withdrawal",
    },
    {
      icon: <BarChartOutlined />,
      label: "Reports",
      color: "cyan",
      path: "/Admin_Panel",
    },
    {
      icon: <SettingOutlined />,
      label: "Settings",
      color: "pink",
      path: "/settings-admin",
    },
    {
      icon: <FileTextOutlined />,
      label: "Website Pages",
      color: "purple",
      path: "/pages",
    },
    {
      icon: <MessageOutlined />,
      label: "Send Message",
      color: "yellow",
      path: "/messages-admin",
    },
  ];

  return (
    <div className="quick-actions-card">
      <h3 className="table-title" style={{ marginBottom: 16 }}>
        Quick Actions
      </h3>

      <div className="quick-actions-grid">
        {actions.map((action, index) => (
          <div
            key={index}
            className={`quick-action-item action-${action.color}`}
            onClick={() => navigate(action.path)}
          >
            <div className="quick-action-icon">{action.icon}</div>
            <p className="quick-action-label">{action.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QuickActions;